let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g1tU0")).then(() => parcelRequire('ge3aY'));